const product = () =>
  import(/* webpackChunkName: "product" */ "./product.vue");

export default {
  name: "软件产品",
  path: "/product",
  component: product,
  meta: {show:true,},
};
